import { GlFilteredSearch, GlSorting } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__, __ } from '~/locale';
import { OPERATORS_IS, OPERATORS_OR, OPERATOR_OR, OPERATOR_IS } from '~/vue_shared/components/filtered_search_bar/constants';
import { SORT_ASC, SORT_DESC, SORT_OPTION_RELEASED, SORT_OPTION_STAR_COUNT, SORT_OPTION_POPULARITY } from '../../constants';
import TopicToken from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/catalog/components/tokens/topic_token.vue?vue3';
import GroupToken from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/catalog/components/tokens/group_token.vue?vue3';
import VerificationLevelToken from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/catalog/components/tokens/verification_level_token.vue?vue3';
export default {
    name: 'CatalogSearch',
    components: {
        GlFilteredSearch,
        GlSorting
    },
    props: {
        initialSearchTerm: {
            default: '',
            required: false,
            type: String
        },
        initialVerificationLevel: {
            default: null,
            required: false,
            type: String
        },
        initialTopics: {
            default: ()=>[],
            required: false,
            type: Array
        },
        initialGroups: {
            default: ()=>[],
            required: false,
            type: Array
        }
    },
    emits: [
        'update-sorting',
        'update-filters'
    ],
    data () {
        const filteredSearchValue = [];
        if (this.initialVerificationLevel) {
            filteredSearchValue.push({
                type: 'verificationLevel',
                value: {
                    data: this.initialVerificationLevel,
                    operator: OPERATOR_IS
                }
            });
        }
        if (this.initialTopics.length) {
            filteredSearchValue.push({
                type: 'topic',
                value: {
                    data: this.initialTopics,
                    operator: OPERATOR_OR
                }
            });
        }
        if (this.initialGroups.length) {
            filteredSearchValue.push({
                type: 'group',
                value: {
                    data: this.initialGroups,
                    operator: OPERATOR_OR
                }
            });
        }
        if (this.initialSearchTerm) {
            filteredSearchValue.push(this.initialSearchTerm);
        }
        return {
            currentSortOption: SORT_OPTION_POPULARITY,
            isAscending: false,
            filteredSearchValue
        };
    },
    computed: {
        currentSortDirection () {
            return this.isAscending ? SORT_ASC : SORT_DESC;
        },
        currentSorting () {
            return `${this.currentSortOption}_${this.currentSortDirection}`;
        },
        currentSortText () {
            const currentSort = this.$options.sortOptions.find((sort)=>sort.value === this.currentSortOption);
            return currentSort.text;
        }
    },
    watch: {
        currentSorting (newSorting) {
            this.$emit('update-sorting', newSorting);
        }
    },
    methods: {
        onSubmit (filters) {
            const searchTerm = filters.filter((f)=>typeof f === 'string').join(' ').trim() || null;
            const verificationLevel = filters.find((f)=>f.type === 'verificationLevel')?.value?.data || null;
            const topics = this.getFilterValue(filters, 'topic');
            const groups = this.getFilterValue(filters, 'group');
            this.$emit('update-filters', {
                searchTerm,
                verificationLevel,
                topics,
                groups
            });
        },
        onSortDirectionChange () {
            this.isAscending = !this.isAscending;
        },
        setSelectedSortOption (sortingItem) {
            this.currentSortOption = sortingItem;
        },
        getFilterValue (filters, type) {
            const filter = filters.find((f)=>f.type === type);
            return filter ? [
                filter.value?.data
            ].flat().filter(Boolean) : [];
        }
    },
    tokens: [
        {
            type: 'verificationLevel',
            title: s__('CiCatalog|Verification level'),
            unique: true,
            token: VerificationLevelToken,
            operators: OPERATORS_IS
        },
        {
            type: 'topic',
            title: s__('CiCatalog|Topic'),
            unique: true,
            multiSelect: true,
            token: TopicToken,
            operators: OPERATORS_OR
        },
        {
            type: 'group',
            title: s__('CiCatalog|Group'),
            unique: true,
            multiSelect: true,
            token: GroupToken,
            operators: OPERATORS_OR
        }
    ],
    sortOptions: [
        {
            value: SORT_OPTION_POPULARITY,
            text: __('Popularity')
        },
        {
            value: SORT_OPTION_RELEASED,
            text: __('Released date')
        },
        {
            value: SORT_OPTION_STAR_COUNT,
            text: __('Star count')
        }
    ]
};
